import React from 'react'
import styles from "./Privacidad.module.css"

function Privacidad() {
  return (
    <div>Aviso de Privacidad</div>
  )
}

export default Privacidad